const hasAdminEditAudit = (auditMetadata) => {
  if (!auditMetadata || typeof auditMetadata !== "object") {
    return false;
  }

  if (auditMetadata.updated === true) {
    return true;
  }

  const changedFields = Array.isArray(auditMetadata.changed_fields)
    ? auditMetadata.changed_fields.filter(Boolean)
    : [];

  return Boolean(
    changedFields.length ||
      auditMetadata.last_updated_at ||
      auditMetadata.last_updated_by ||
      auditMetadata.last_edited_at ||
      auditMetadata.last_edited_by ||
      auditMetadata.last_reviewed_at ||
      auditMetadata.last_reviewed_by
  );
};

const buildAuditPanelState = (auditMetadata) => {
  const lastEditedBy = auditMetadata?.last_edited_by || "Unavailable";
  const lastEditedAt = auditMetadata?.last_edited_at || "Unavailable";
  const lastReviewedBy = auditMetadata?.last_reviewed_by || "Unavailable";
  const lastReviewedAt = auditMetadata?.last_reviewed_at || "Unavailable";
  const changedFields = Array.isArray(auditMetadata?.changed_fields)
    ? auditMetadata.changed_fields.filter(Boolean)
    : [];

  return {
    lastEditedBy,
    lastEditedAt,
    lastReviewedBy,
    lastReviewedAt,
    changedFields,
    shouldShowLastEditedBy: lastEditedBy !== "Unavailable",
    shouldShowLastEditedAt: lastEditedAt !== "Unavailable",
    shouldShowLastReviewedBy: lastReviewedBy !== "Unavailable",
    shouldShowLastReviewedAt: lastReviewedAt !== "Unavailable",
    shouldShowChangedFields: changedFields.length > 0,
    hasEditAudit: hasAdminEditAudit(auditMetadata),
  };
};

export { buildAuditPanelState, hasAdminEditAudit };
